import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-012258d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "box-dialog" }
const _hoisted_3 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: $setup.statusPaid,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.statusPaid) = $event)),
      width: "90%",
      "show-close": false,
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.logout())),
            class: "button-size mb-2 secondary__color__button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("dialogContinuePay.logoutButton")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "button-size mb-2 primary__color__button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goToCheckout()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("dialogContinuePay.checkoutButton")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("dialogContinuePay.title")), 1),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("dialogContinuePay.message")), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}